import {createSlice} from '@reduxjs/toolkit'
import { H3User, LOCAL_STORAGE_USER } from '../../auth'

const initialState: H3User = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER) as string) as H3User | object as H3User

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUser: (state, action) => {
            const {payload} = action

            let jsonValue = JSON.stringify(payload)

            try {
                window.localStorage.setItem(LOCAL_STORAGE_USER, jsonValue)

            } catch (error) {
                console.debug(
                    `Failed to set localStorage key ${LOCAL_STORAGE_USER} to value ${jsonValue}: ${error}`
                )
            }

            return {
                ...state,
                ...action.payload,
            }
        },
        clearUser: () => {
            window.localStorage.setItem(LOCAL_STORAGE_USER, JSON.stringify({}))

            return {} as H3User
        }
    }
})

const { actions, reducer } = userSlice
export const { setUser, clearUser } = actions

export default reducer
